module.exports = {"data":{"site":{"siteMetadata":{"algolia":{"appId":"2049MPCLGO","searchOnlyApiKey":"e41443b3fd6416560ab6a167ccbe61e0","indexName":"BlogIndex"}}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/search.json
// module id = 789
// module chunks = 254572558124955